
export default {
  name: 'MktLogoBlog',
  computed: {
    height() {
      return this.$mq === 'default' ? 36 : 46;
    },
  },
};
